import { MyServicesListingInstallation, MyServicesListingSociety } from '@core/domain/model/services/my-services-listing.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MyServicesFilterFormModel } from '@pages/my-services/my-services-listing/model/my-services-filter-form.model';
import { PaginatorInput } from '@shared/components/paginator/models/paginator-input.model';
import { SortEvent } from '@shared/components/table/sort/model/sort.model';

export const myServicesActions = createActionGroup({
  source: 'MyServices',
  events: {
    fetchListingData: emptyProps,
    setListingData: props<{ superData: Array<MyServicesListingSociety>; subData: Record<string, MyServicesListingInstallation[]> }>(),
    setListingDataError: props<{ error: string }>(),
    setListingDataFilters: props<{ filters: MyServicesFilterFormModel | PaginatorInput | SortEvent }>(),
  },
});
